import type { TRootElement } from '@/rootElement/Root.types';
import type { BasicNode } from '@/types';

export const findContentGateIndex = (pageContent: TRootElement) =>
  pageContent.content.findIndex((node) => node.type === 'contentGate');

export function truncateAfterContentGate(pageContent: TRootElement): TRootElement | BasicNode[] {
  const contentGateIndex = findContentGateIndex(pageContent);

  if (contentGateIndex === -1) {
    return pageContent;
  }

  return pageContent.content.slice(0, contentGateIndex + 1);
}
